import { HttpEventType } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { PatientHistoryEntry } from 'src/app/data/patient-history-entry';
import { TokenPermissions } from 'src/app/data/permissions';
import { Study } from 'src/app/data/study';
import { AlertService } from 'src/app/services/alert.service';
import { BookService } from 'src/app/services/book.service';
import { ConfigService } from 'src/app/services/config.service';
import { PatientHistoryService } from 'src/app/services/patient-history.service';
import { PermissionService } from 'src/app/services/permission.service';
import { StudiesService } from 'src/app/services/studies.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-historical-modal-mobile',
  templateUrl: './historical-modal-mobile.component.html',
  styleUrls: ['./historical-modal-mobile.component.css']
})
export class HistoricalModalMobileComponent implements OnInit {

  @Input() token!: string;

  opened: boolean = false;

  TokenPermissions = TokenPermissions;
  window = window;
  environment = environment;

  downloading: { studyUID: string | null, percentage: number } | null = null
  obtaining: Set<string> = new Set();

  bookStudies: Study[] = [];

  locator?: string;

  isWaitingForStudy: boolean = false;

  historic: PatientHistoryEntry[] = [];
  get historicWithoutFirst() {
    return this.historic.filter((st, index) => index != 0)
  }

  constructor(
    private alertService: AlertService,
    public permissionService: PermissionService,
    private studiesService: StudiesService,
    public configService: ConfigService,
    public bookService: BookService,
    private historyService: PatientHistoryService,

  ) { }

  ngOnInit(): void {

    if (this.token == null) {
      setTimeout(() => {
        this.ngOnInit();
      }, 100);
      return;
    }


    this.studiesService.getStudiesByToken(this.token).then(sts => {
      // console.log('this.bookStudies', sts);
      this.bookStudies = sts;
      this.historyService.loadHistoryForBookToken(this.token).then(entries => {
        // console.log('historic1', entries);
        this.historic = entries.filter(s => this.bookStudies.findIndex(st => st.studyUID == s.studyUID) == -1);
        this.historic.sort((a, b) => b.date!.getTime() - a.date!.getTime());
        console.log('historic2', this.historic);
      }).catch(error => {
        console.error(error);
      })
    }).catch(error => {
      console.error(error);
    })

    this.bookService.getLocatorByToken(this.token).then(locator => {
      this.locator = locator;
    }).catch(error => {
      console.error(error);
    })


  }

  openModal() {
    this.opened = true;
  }

  closeModal() {
    this.opened = false;
  }

  onClickOpenBook(book: PatientHistoryEntry) {
    if (book != null) {
      console.log(book);
      console.log(book.studyToken);
      const url = `/book-pdf?tkn=${book.studyToken}`;
      // window.open(url, '', 'toolbar=no,top=10,left=10,width=' + (screen.width - 50) + ',height=' + (screen.height - 100));
      this.window.location.href = url;
    }
  }

  onClickObtainStudy(study: Study) {

    if (!this.obtaining.has(study.studyUID!)) {
      this.obtaining.add(study.studyUID!);

      this.isWaitingForStudy = true;

      setTimeout(() => {
        if (environment.demo) {
          const interval = setInterval(() => {
            this.obtaining.delete(study.studyUID!);
          }, 75)
        } else {


          this.studiesService.askForStudy(study.studyUID!).then(() => {

          }).catch(e => {
            console.error(e)
            setTimeout(() => {
              this.obtaining.delete(study.studyUID!);
              clearInterval(interval);
              this.alertService.alert('Ha ocurrido un error tratando de recuperar el estudio. Contacte con su centro');
            })
          })
          const interval = setInterval(() => {
            this.studiesService.checkStudyStatus(study.studyUID!).subscribe(bol => {
              if (bol) {
                this.obtaining.delete(study.studyUID!);
                study.status = 'READY';
                clearInterval(interval);
              }
            })

          }, 7000);

        }
      }, 1200);
    }
  }

  onClickSeeStudy(study?: PatientHistoryEntry) {
    let studyUID: string | null = null;
    if (study != null) {
      studyUID = study.studyUID;
    } else {
      studyUID = this.bookService.currentBook!.studyUIDs[0]
    }
    if (studyUID == null) {
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
      return;
    }
    console.log('studyUID; ', studyUID);
    this.configService.getConfig().then(c => {
      const route = `${c.visorRoute}?sid=${studyUID}`;
      let visorWindow = window.open(route, 'Visor', 'toolbar=no,top=10,left=10,width=' + (screen.width - 50) + ',height=' + (screen.height - 100));
      if (study == null && this.bookStudies.length > 1) { // si se ha hecho click en el general y hay más de un estudio en el book
        // Enviamos los estudios de uno en uno cada 1.5s
        setTimeout(() => {
          const sendNext = (index: number) => {
            if (index >= this.bookStudies.length)
              return;
            const st = this.bookStudies[index];
            const data = {
              order: 'loadSerie',
              data: { studyUID: st.studyUID }
            };
            visorWindow?.postMessage(data, '*');
            setTimeout(() => {
              sendNext(++index)
            }, 1500);
          }
          sendNext(1);
        }, 3000);
      }
    })
  }

  onClickDownload(study?: PatientHistoryEntry) {
    let studyUIDs: string[] = [];
    if (study != null) {
      studyUIDs = [study.studyUID!];
    } else {
      studyUIDs = this.bookStudies.map(st => st.studyUID!);
    }
    if (studyUIDs.length == 0) {
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
      return;
    }
    this.downloadStudies(studyUIDs);
  }

  downloadStudies(studyUIDs: string[]) {
    if (this.downloading == null) {
      this.downloading = { studyUID: (studyUIDs.length == 1) ? studyUIDs[0] : null, percentage: 0 }
      setTimeout(() => {
        if (environment.demo) {
          const interval = setInterval(() => {
            if (++this.downloading!.percentage == 100) {
              clearInterval(interval);
              this.downloading = null;
            }
          }, 75)
        } else {
          let startedDownloading = false;
          const randomIntFromInterval = (min, max) => { // min and max included 
            return Math.floor(Math.random() * (max - min + 1) + min)
          }
          const interval = setInterval(() => {
            if (startedDownloading) {
              clearInterval(interval);
            } else {
              if (this.downloading!.percentage < 10) {
                this.downloading!.percentage += (randomIntFromInterval(0, 30) / 100) // ~ 1m 15s
              } else if (this.downloading!.percentage < 20) {
                this.downloading!.percentage += (randomIntFromInterval(10, 30) / 100) // ~ 1m
              } else if (this.downloading!.percentage < 30) {
                this.downloading!.percentage += (randomIntFromInterval(10, 50) / 100) // ~ 35s
              } else if (this.downloading!.percentage < 35) {
                this.downloading!.percentage += (randomIntFromInterval(0, 10) / 100) // ~ 1m 50s
              } else if (this.downloading!.percentage < 50) {
                this.downloading!.percentage += (randomIntFromInterval(0, 7) / 100) // ~ 8m
              }
            }
          }, 1200);
          this.studiesService.downloadStudies(studyUIDs).subscribe(event => {
            if (event!.type == HttpEventType.DownloadProgress) {
              startedDownloading = true;
              const percentage = ((event!.loaded / event!.total!) * 50) + 50
              console.log('percentage: ', percentage);
              this.downloading!.percentage = Math.round(percentage)
            }
            if (event!.type == HttpEventType.Response) {
              const link = document.createElement('a');
              if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(event!.body!);
                link.setAttribute('href', url);
                link.setAttribute('download', "dicomdir.zip");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
              this.downloading = null;
            }
          })
        }
      }, 1);
    } else {
      this.alertService.alert('Ya se está descargando un estudio. Por favor, espere a que finalice')
    }
  }

  closeWaitingModal() {
    this.isWaitingForStudy = false;
  }

  goToPortalLogin() {
    this.configService.getConfig().then(c => {
      const url = `${c.portal_url}/login/professional?r=hce`;
      window.location.href = url;
    });
  }

  goToPortalRegister() {
    this.configService.getConfig().then(c => {
      const url = `${c.portal_url}/mailVerification`;
      window.location.href = url;
    });
  }



}
